(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["accordion-contents"] && !window.DesignMode) return;
  try {
    
	(function ($) {
		let accordionBtn = $('.pr-accordion-button'),
				accordionInnerBtnClose = $('.pr-accordion-inner-button-close'),
				accordionTime = 300,
				slideSpeed = 500,
        hash_id = location.hash,
        total_sel = $('#main').find('.shopify-section').length;
        //target = $(hash_id).find('.pr-accordion-button');

    let before_sel;
    let after_sel;
    let current_ac;
        /***一番直近のアコーディオンを動作させる***/

        /**指定された要素**/
        before_sel = $(hash_id).parents('.shopify-section');
        before_sel.addClass('js-start');
        /*IDがあれば（アンカーである）*/
    if(hash_id){
          /*見つかるまで探す*/
          for(let loop = 0; loop < 2; loop++) {
            after_sel = before_sel.next();
            current_ac = after_sel.find('.pr-accordion-button');
            after_sel.addClass('js-loop' + loop + 1);
            /*この中にアコーディオンが存在するか*/
            if(current_ac.length > 0) {
              setTimeout(function(){
                current_ac.click();
              },1000);
            }
            before_sel = after_sel;



            
          }
        }
    /*if(hash_id){
      setTimeout(function(){
        target.click();
      },1000);
    }*/

		accordionBtn.on('click', function(){
			let accordionBtnOpen = $(this).find('.pr-accordion-button-open'),
					accordionBtnClose = $(this).find('.pr-accordion-button-close'),
					accordionBody = $(this).next();

			setTimeout(function(){
				accordionBtnOpen.toggleClass('js-accordion-button-hidden');
				accordionBtnClose.toggleClass('js-accordion-button-hidden');
			}, accordionTime);

			accordionBody.slideToggle(slideSpeed);
			accordionBody.toggleClass('pr-accordion-hidden');
		});

		accordionInnerBtnClose.on('click', function(){
			let accordionBody = $(this).parent(),
					accordionWrapper = accordionBody.parent(),
					accordionWrapperOffset = accordionWrapper.offset().top,
					accordionBtn = accordionBody.prev(),
					accordionBtnOpen = accordionBtn.find('.pr-accordion-button-open'),
					accordionBtnClose = accordionBtn.find('.pr-accordion-button-close');

			accordionBody.toggleClass('pr-accordion-hidden').slideToggle(slideSpeed);
			accordionBtnOpen.toggleClass('js-accordion-button-hidden');
			accordionBtnClose.toggleClass('js-accordion-button-hidden');

			setTimeout(function(){
				$(window).scrollTop(accordionWrapperOffset - 150);
			}, slideSpeed);
		});

	})(jQuery);

  } catch(e) { console.error(e); }
})();

})();
